module.exports = __webpack_public_path__ + "img/lock-menu.2972af6c.svg";